import { render, staticRenderFns } from "./AvailabilityProduct.vue?vue&type=template&id=34b20086&scoped=true&"
import script from "./AvailabilityProduct.vue?vue&type=script&lang=js&"
export * from "./AvailabilityProduct.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityProduct.vue?vue&type=style&index=0&id=34b20086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b20086",
  null
  
)

export default component.exports